import React from 'react';
import TabledisenoCurricularModulos from './TableDisenoCurricularModulos/TableDisenoCurricularModulos';

const DisenoCurricularModulos = () => {
  return <TabledisenoCurricularModulos/> ;
};

export default DisenoCurricularModulos;
